import {
  API_KEYS_REQUEST,
  BASIC,
  SCOPE_CODE,
  SCOPE_FILTER_ID,
  SCOPE_FILTER_TYPE,
} from 'consts';
import { client } from 'util/sdk';
import { GET, DELETE, POST } from 'util/api';
import { stringToInt } from 'util/consts';
import { omit, pick } from 'ramda';
import { getScopeData } from 'components/modules/implementation/ApiKey/List/Form/Fields/Chip/ChipScopes';

const keys = [
  'name',
  'owner',
  'type',
  'clientKey',
  'clientSecret',
  'accessExpSec',
  'refreshExpSec',
  'ipv4s',
  'cidrs',
  'scopes',
  'roles',
];
const returnModel = { name: 'apikey' };
const scopeCode = [SCOPE_CODE];

export const load = async (params) => {
  const [scopeType, scopeId] = getScopeData(params?.scope);
  const paramsWithScope = {
    ...omit(scopeCode, params),
    ...(scopeId && {
      [SCOPE_FILTER_TYPE]: scopeType,
      [SCOPE_FILTER_ID]: scopeId,
    }),
  };

  const urlToHit = `/${API_KEYS_REQUEST}`;
  return client.executeRequest(GET, urlToHit, {
    queryParams: paramsWithScope,
    returnModel,
  });
};

export const add = async (data, auth) => {
  const urlToHit = `/${API_KEYS_REQUEST}`;
  return client.executeRequest(POST, urlToHit, {
    data: pick(keys, setValuesToSend(data)),
    queryParams: { adminUserId: auth.id },
    returnModel,
  });
};

const setValuesToSend = (data) => {
  const isBasic = data.type === BASIC;
  return {
    ...data,
    ipv4s: data.allAPIs?.filter((item) => !item.includes('/')) ?? [],
    cidrs: data.allAPIs?.filter((item) => item.includes('/')) ?? [],
    accessExpSec: !isBasic ? stringToInt(data.accessExpSec) : null,
    refreshExpSec: !isBasic ? stringToInt(data.refreshExpSec) : null,
  };
};

export const update = async ({ id, ...data }, auth) => {
  const urlToHit = `/${API_KEYS_REQUEST}`;
  return client.executeRequest(POST, `${urlToHit}/${id}`, {
    data: pick(keys, setValuesToSend(data)),
    queryParams: { adminUserId: auth.id },
    returnModel,
  });
};

export const remove = async ({ id }, auth) => {
  const urlToHit = `/${API_KEYS_REQUEST}`;
  return client.executeRequest(DELETE, `${urlToHit}/${id}`, {
    queryParams: { adminUserId: auth.id },
    returnModel,
  });
};
